import type { ReactNode } from 'react';
import type { Product } from '@kon/shared';
import { ProductCardSkeleton } from '@/components/common/Skeleton';
import { ProductCard } from './ProductCard';
import styles from './ProductGrid.module.css';

interface ProductGridProps {
  products: Product[];
  loading?: boolean;
  skeletonCount?: number;
  /** Rendered (spanning the grid) when there are no products and not loading. */
  empty?: ReactNode;
  /** Eager-load the first N images (above the fold). */
  eagerCount?: number;
}

export function ProductGrid({
  products,
  loading = false,
  skeletonCount = 8,
  empty,
  eagerCount = 0,
}: ProductGridProps) {
  if (loading && products.length === 0) {
    return (
      <div className={styles.grid} aria-busy="true">
        {Array.from({ length: skeletonCount }, (_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (products.length === 0) {
    return <div className={styles.grid}>{empty}</div>;
  }

  return (
    <div className={styles.grid}>
      {products.map((product, i) => (
        <ProductCard key={product.id} product={product} loading={i < eagerCount ? 'eager' : 'lazy'} />
      ))}
    </div>
  );
}
